import type { ServerConfig } from "@attensi/frontend-server"

const config = {
  env: [
    "VITE_ADMIN_URL",
    "VITE_API_TOKEN",
    "VITE_APP_ENV",
    "VITE_AUTH_URL",
    "VITE_BACKOFFICE_API_URL",
    "VITE_LEADERBOARD_API_URL",
    "VITE_LOGIN_URL",
    "VITE_SCORM_URL",
  ],

  optionalEnv: [
    "GIT_COMMIT_SHA",
    "VITE_OPTIMIZER_URL",
    "VITE_CHAT_API_URL",
    "VITE_CHAT_WS_URL",
  ],

  envPrefix: "VITE_",

  publicRoot: "./dist",

  isImmutableFile: ({ dir }) => dir.endsWith("assets"),

  contentSecurityPolicy: {
    imgSrc: ["https:"],
    scriptSrc: [
      "*.attensi.com",
      // Video embedding platforms
      "https://www.youtube.com",
      "https://www.youtube-nocookie.com",
      "https://player.vimeo.com",
      "https://vimeo.com",
      "https://fast.wistia.com",
      "https://fast.wistia.net",
      "https://embed.ted.com",
      "https://*.sharepoint.com",
      "https://*.microsoftonline.com",
      "https://www.loom.com",
      "https://cdn.loom.com",
    ],
    workerSrc: ["'self' blob:"],
    connectSrc: [
      // Setting connect-src overrides default-src, so 'self' must be repeated
      // here or same-origin requests are only allowed by the wildcard below.
      "'self'",
      "*.attensi.com",
      "*.sentry.io",
      "localhost:*",
      // Diploma download outputs a data: URL, which file-saver probes with an
      // XHR before saving. See tools/useDownloadHTMLAsPDF.ts
      "data:",
      // files that must come directly from S3 to avoid CORS issues
      "https://attensi-portal-production.s3.eu-central-1.amazonaws.com",
      "https://attensi-portal-eu-staging.s3.eu-central-1.amazonaws.com",
    ],
    frameSrc: "*",
    // Journey backgrounds may be mp4, served from the same origins as images.
    // 'self' is required: setting media-src at all drops the default-src fallback.
    mediaSrc: ["'self'", "https:"],
    objectSrc: ["data:"],
    reportUri: "https://attensi.report-uri.com/r/t/csp/reportOnly",
    reportOnly: true,
  },

  // TODO
  // This allows embedding entire Engage in an iframe and is a temporary solution!
  // Only specific routes should be allowed to be embeddable, but it requires changes in frontend-server
  helmetConfig: {
    xFrameOptions: false,
  },
} as const satisfies ServerConfig

export default config
